// FILTER_NAME_CONSTANTS
export const ENTITY_TYPE_FILTER = "ENTITY_TYPE_FILTER";
export const FILE_FOLDER_FILTER = "FILE_FOLDER_FILTER";
export const TEXTUAL_SEARCH_IMAGE = "TEXTUAL_SEARCH_IMAGE";
export const TEXTUAL_SEARCH_OBJECT = "TEXTUAL_SEARCH_OBJECT";
export const VISUAL_SEARCH = "VISUAL_SEARCH";
export const ACTIONS_CART = "ACTIONS_CART";
export const EXPLORATION_STATS = "EXPLORATION_STATS";
export const CLUSTER_METADATA_SUMMARY = "CLUSTER_METADATA_SUMMARY";
export const DATA_METADATA_SUMMARY = "DATA_METADATA_SUMMARY";
export const FIND_SIMILAR_OBJECT_FILTER = "FIND_SIMILAR_OBJECT";
export const SHOW_DS_VERSION = "SHOW_DS_VERSION";
export const ENABLE_DS_DUPLICATE = "ENABLE_DS_DUPLICATE";

export const AUTO_SUGGEST_RECENT_SEARCH = "AUTO_SUGGEST_RECENT_SEARCH";
export const AUTO_SUGGEST_QUERY = "AUTO_SUGGEST_QUERY";

export const REGION_SELECTION_SIMILARITY = "REGION_SELECTION_SIMILARITY";
export const ASSET_PREVIEW = "ASSET_PREVIEW";
export const EXPORT_ENTITIES = "EXPORT_ENTITIES";
export const DATA_INGESTION_TAB_AVAILABLE = "DATA_INGESTION_TAB_AVAILABLE";
export const USAGE_REPORT = "USAGE_REPORT";
export const DELETE_DATASET = "DELETE_DATASET";
export const EXPLORATION_DEBUG_INFO = "EXPLORATION_DEBUG_INFO";
export const DATASET_SHARE = "DATASET_SHARE";
export const CVAT_INTEGRATION = "CVAT_INTEGRATION";
export const ENRICHMENT_PREVIEWS = "ENRICHMENT_PREVIEWS";
export const RIGHT_PANE_MODEL_SELECTION = "RIGHT_PANE_MODEL_SELECTION";
export const SAVED_VIEWS = "SAVED_VIEWS";
export const SAVED_VIEWS_SHARE = "SAVED_VIEWS_SHARE";
export const CLUSTER_BY_DUPLICATES = "CLUSTER_BY_DUPLICATES";
export const UNIQUENESS_SCORE = "UNIQUENESS_SCORE";
export const PROMPT_SUPPORT_ENABLED = "PROMPT_SUPPORT_ENABLED";
export const MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS =
  "MISLABEL_CONFIDENCE_FILTER_FOR_OBJECTS";
export const MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES =
  "MISLABEL_CONFIDENCE_FILTER_FOR_IMAGES";
export const DYNAMIC_TEXTUAL_SIMILARITY_THRESHOLD =
  "DYNAMIC_TEXTUAL_SIMILARITY_THRESHOLD";
export const ENRICHMENT_ENRICH_DATASET = "ENRICHMENT_ENRICH_DATASET";
export const VL_LIGHT_MODE = "VL_LIGHT_MODE";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_OBJECTS";
export const TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES =
  "TEXTUAL_SEARCH_RELEVANCE_SCORE_IMAGES";
export const NEW_FILTERS_PANEL = "NEW_FILTERS_PANEL";
export const CUSTOM_METADATA_ENABLED = "CUSTOM_METADATA_ENABLED";
export const OBJECT_SIZE_FILTER_ENABLED = "OBJECT_SIZE_FILTER_ENABLED";
export const FLYWHEEL="FLYWHEEL";
export const VL_CHAT = "VL_CHAT";